import { LOGIN_I18N_KEYS } from '../../../../features/login/constants/i18n/Logini18nConstants';

export const LOGIN_I18N_EN = {
  [LOGIN_I18N_KEYS.password_reset_email_sent]:          "Password reset link sent to {{userEmail}}.",
  [LOGIN_I18N_KEYS.error_sending_password_reset_email]: "Error sending password reset email.",
}


// WEBPACK FOOTER //
// ./src/locales/en/features/login/login.i18n.en.js